export const dnldErrorCodes = (builder) => ({
    dnldErrorCodes: builder.mutation({
        query: ({  search, campaignType, loggedin_user_id, user_type_id, startDate, endDate }) => {
            return {
                url: '/downloadErrorCodeSummary',
                method: 'GET',
                params: {  search, campaignType, loggedin_user_id, user_type_id, startDate, endDate  },
                headers: {
                    'Content-Type':  'text/csv', 
                },
                responseHandler: (response) => response.blob(),
            };
        },
    }),
});